// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__327IG","boxTitle":"Qualiphy_boxTitle__2iYed","box":"Qualiphy_box__2jnok","toggleWrap":"Qualiphy_toggleWrap__1bD03"};